import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { WalletService } from '../../Service/wallet/wallet.service';

@Component({
  selector: 'app-recharge-wallet-popup',
  templateUrl: './recharge-wallet-popup.component.html',
  styleUrl: './recharge-wallet-popup.component.scss'
})
export class RechargeWalletPopupComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  availableBalance: number = 0;
  @Output() close = new EventEmitter<void>();

  constructor(private router: Router, private wallet: WalletService) { }

  ngOnInit(): void {
    this.fetchBalance()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.fetchBalance();
    }
  }

  fetchBalance(): void {
    this.wallet.getWalletBalance().subscribe({
      next: (res) => {
        this.availableBalance = res?.availableBalance ?? 0;
      },
      error: () => {
        this.availableBalance = 0;
      }
    });
  }
  dismiss() {
    this.visible = false;
    this.close.emit();
  }
  goToWallet(): void {
    const role = JSON.parse(localStorage.getItem('user') || '{}')?.accessType;

    if (role === 1) {
      this.router.navigate(['/c-sp/wallet']);
    } else if (role === 4) {
      this.router.navigate(['/distributor-partners/wallet'])
    }

    this.visible = false;
    this.close.emit();
  }
}